<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row :gutter="16" class="filter__container">
       <!-- First Name -->
      <el-col 
        :lg="6" 
        :md="16" 
        :sm="24"
      >
        <el-form-item
          :label="fields.firstName.label"
          :prop="fields.firstName.name"
        >
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.firstName.label}}</span>
            <el-button v-if="model.firstName" type="text" @click="resetFieldFilter({ fieldKey: 'firstName'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input 
            v-model="model[fields.firstName.name]"
            :placeholder="fields.firstName.label"
            @input.native="debounceInput"
            @clear="doFilter"
            prefix-icon="icon-player"
          />
        </el-form-item>
      </el-col>

      <!-- Last Name -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item
          :label="fields.lastName.label"
          :prop="fields.lastName.name"
        >
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.lastName.label}}</span>
            <el-button v-if="model.lastName" type="text" @click="resetFieldFilter({ fieldKey: 'lastName'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input 
            v-model="model[fields.lastName.name]"
            :placeholder="fields.lastName.label"
            @input.native="debounceInput"
            @clear="doFilter"
            prefix-icon="icon-player"
          />
        </el-form-item>
      </el-col>

      <!-- Gender -->
      <el-col :lg="5" :md="16" :sm="24">
        <el-form-item  :prop="fields.gender.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.gender.label}}</span>
            <el-button v-if="model.gender" type="text" @click="resetFieldFilter({ fieldKey: 'gender'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select 
            :placeholder="fields.gender.label" 
            v-model="model[fields.gender.name]"
            @change="doFilter"
          >
             <i
                  slot="prefix"
                  class="icon-family"
              />
            <el-option :value="undefined">--</el-option>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.gender.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

              
      <!-- Birthdate Range -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item 
          :label="fields.birthdateRange.label" 
          :prop="fields.birthdateRange.name"
        >
          <div class="form__item__label__slot" slot="label">
            <span v-text="fields.birthdateRange.label" />
            <el-button
              v-if="enabledResetDateField"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'birthdateRange'})"
            >
              <app-i18n code="common.reset"/>
            </el-button>
          </div>
          <!-- Watched -->
          <el-date-picker
            v-model="model[fields.birthdateRange.name]"
            type="monthrange"
            format="MM/yyyy"
          />
        </el-form-item>
      </el-col> 

      <!-- Reset Button -->
      <el-col :lg="1" :md="16" :sm="24">
          <div class="filter-buttons">
            <el-button
              :disabled="loading"
              @click="doResetFilter"
              icon="icon-undo"
              circle
            />
          </div>
        </el-col>
    </el-row>

    <!-- <div class="filter-buttons">
      <el-button :disabled="loading" @click="doFilter" icon="el-icon-fa-search" type="primary">
        <app-i18n code="common.search"></app-i18n>
      </el-button>
    </div> -->
  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { PlayerModel } from '@modules/player/player-model';
import { i18n } from '@shared/i18n';
import _ from 'lodash';

export default {
  name: 'app-player-list-filter',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'player/list/loading',
      filter: 'player/list/filter',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },
    rules() {
      const { filterSchema } = this;
      return filterSchema.rules();
    },
    filterSchema() {
      const { fields } = this;
      return new FilterSchema([
        fields.id,
        fields.firstName,
        fields.lastName,
        fields.gender,
        fields.birthdateRange,
        fields.team,
      ]);
    },
    fields() {
      const { dateFormat, timeFormat} = this;
      return new PlayerModel({
        dateFormat, timeFormat
      }).fields();
    },

    enabledResetDateField() {
      const isArray = Array.isArray(this.model.birthdateRange);
      const size = isArray ? this.model.birthdateRange.length : 0;
      return size > 1;
    }
  },

  async mounted() {
    const { filterSchema } = this;
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );
  },

  methods: {
    ...mapActions({
      doReset: 'player/list/doReset',
      doFetch: 'player/list/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this;
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = this.getFilterOptions();
      
      
      return this.doFetch({
        filter,
      });
    },

    getFilterOptions() {  
      const { filterSchema } = this;    
      const filter = filterSchema.cast(this.model);
      return filter;
    },
    
    i18n(code) {
      return i18n(code);
    },
  },

  watch: {
    'model.birthdateRange': 'doFilter'
  },
};
</script>

<style>
</style>
